(function () {
  'use strict';

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function createChevron(className) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    if (className) svg.setAttribute('class', className);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    path.setAttribute('d', 'm9 5 7 7-7 7');
    svg.appendChild(path);
    return svg;
  }

  function setCopy(root, selector, copy) {
    var element = root && root.querySelector(selector);
    if (element) element.textContent = copy;
  }

  function refinePrerequisiteCard(card, eyebrow, title, text, buttonText) {
    if (!card) return;

    setCopy(card, '.zv-mini-card__eyebrow', eyebrow);
    setCopy(card, '.zv-mini-card__title', title);
    setCopy(card, '.zv-mini-card__text', text);

    var button = card.querySelector('.zv-mini-card__button');
    var buttonLabel = card.querySelector('.zv-mini-card__button-text');
    if (!buttonLabel && button) buttonLabel = button.querySelector('span:last-child');
    if (buttonLabel) buttonLabel.textContent = buttonText;
    if (button && button.parentElement !== card) card.appendChild(button);
    card.classList.add('zv-mini-card--refined');
  }

  function refinePrerequisites(prerequisites) {
    if (!prerequisites || !prerequisites.classList.contains('zv-prerequisites')) return;

    setCopy(prerequisites, '.zv-prerequisites__eyebrow', 'Benodigd voor deze handleiding');
    setCopy(prerequisites, '.zv-prerequisites__title', 'Base en P1-dongle in dezelfde Home');
    setCopy(
      prerequisites,
      '.zv-prerequisites__subtitle',
      'Controleer in de ZinVolt-app of beide onderdelen binnen dezelfde Home zichtbaar zijn.'
    );

    var badges = prerequisites.querySelectorAll('.zv-prerequisites__badges span');
    if (badges[0]) badges[0].textContent = 'ZinVolt Base zichtbaar';
    if (badges[1]) badges[1].textContent = 'P1-dongle PRO zichtbaar';

    var cards = prerequisites.querySelectorAll('.zv-mini-card');
    refinePrerequisiteCard(
      cards[0],
      'Base nog niet gekoppeld?',
      'ZinVolt Base koppelen',
      'Volg eerst de Base-handleiding.',
      'Open Base-handleiding'
    );
    refinePrerequisiteCard(
      cards[1],
      'P1-dongle nog niet gekoppeld?',
      'P1-dongle PRO koppelen',
      'Voeg de dongle toe aan dezelfde Home.',
      'Open P1-handleiding'
    );
  }

  function enhanceGuideIntro() {
    document.querySelectorAll('.zv-guide').forEach(function (guide) {
      var header = guide.querySelector('.zv-guide__header');
      var download = guide.querySelector('.zv-download');

      if (header && download && !header.contains(download)) {
        download.classList.add('zv-guide__hero-download');
        header.classList.add('zv-guide__header--with-downloads');
        header.appendChild(download);
      }

      var grid = guide.querySelector('.zv-guide__grid');
      if (!grid || grid.querySelector('.zv-guide-overview')) return;

      Array.prototype.slice.call(grid.children).forEach(function (card) {
        if (!card.classList.contains('zv-card')) return;

        var title = card.querySelector('.zv-card__title');
        var details = createElement('details', 'zv-guide-overview');
        var summary = createElement('summary', 'zv-guide-overview__summary');
        var summaryTitle = createElement(
          'span',
          'zv-guide-overview__title',
          title ? title.textContent.trim() : 'Bekijk de voorbereiding'
        );
        var body = createElement('div', 'zv-guide-overview__body');

        summary.append(summaryTitle, createChevron('zv-guide-overview__chevron'));
        if (title) title.remove();
        while (card.firstChild) body.appendChild(card.firstChild);
        details.append(summary, body);
        grid.replaceChild(details, card);
      });
    });
  }

  function initGuide() {
    enhanceGuideIntro();
    if (document.querySelector('[data-zv-guide-workspace]')) return;

    var steps = Array.prototype.slice.call(document.querySelectorAll('[data-zv-guide-step]'));
    if (!steps.length) return;

    var sourceSections = [];
    var sourceSteps = [];
    steps.forEach(function (step) {
      var source = step.closest('.shopify-section');
      if (source && sourceSections.indexOf(source) === -1) sourceSections.push(source);
      sourceSteps.push({ source: source, step: step });
    });

    document.querySelectorAll('[data-zv-guide-spacing]').forEach(function (spacing) {
      var source = spacing.closest('.shopify-section');
      if (source) source.classList.add('zv-guide-source-spacing');
    });

    var firstSource = sourceSections[0];
    if (!firstSource || !firstSource.parentNode) return;
    var pageParent = firstSource.parentNode;
    var pageSections = Array.prototype.slice.call(pageParent.children);
    var firstSourceIndex = pageSections.indexOf(firstSource);
    var contextSelector = [
      '.zv-tech-check',
      '.zv-calibration-check',
      '.zv-manual-download',
      '.zv-pdf-alert',
      '.zv-prerequisites',
      '.zv-attention-block',
      '.zv-multi-base-link'
    ].join(',');
    var preflightSelector = '.zv-prerequisites';
    var contextAssignments = [];
    var preflightSections = [];

    pageSections.forEach(function (section) {
      var context = section.querySelector && section.querySelector(contextSelector);
      if (!context) return;

      var sectionIndex = pageSections.indexOf(section);
      if (sectionIndex < firstSourceIndex && context.matches('.zv-attention-block')) {
        section.classList.add('zv-guide-preflight-remove');
        return;
      }
      if (sectionIndex < firstSourceIndex && context.matches(preflightSelector)) {
        preflightSections.push({ source: section, context: context });
        return;
      }

      var previousSource = null;
      var nextSource = null;

      sourceSections.forEach(function (source) {
        var sourceIndex = pageSections.indexOf(source);
        if (sourceIndex < sectionIndex && (!previousSource || sourceIndex > pageSections.indexOf(previousSource))) {
          previousSource = source;
        }
        if (sourceIndex > sectionIndex && (!nextSource || sourceIndex < pageSections.indexOf(nextSource))) {
          nextSource = source;
        }
      });

      var candidates = sourceSteps.filter(function (item) {
        return item.source === (previousSource || nextSource);
      });
      var target = previousSource ? candidates[candidates.length - 1] : candidates[0];
      if (target) contextAssignments.push({ source: section, target: target.step });
    });

    var legacyContactSections = pageSections.filter(function (section) {
      return section.querySelector && section.querySelector('.zv-contact-page.contact-form');
    });

    var workspace = createElement('section', 'zv-guide-workspace');
    workspace.setAttribute('data-zv-guide-workspace', '');
    workspace.setAttribute('aria-label', 'Interactieve installatiehandleiding');

    var rail = createElement('aside', 'zv-guide-workspace__rail');
    var eyebrow = createElement('p', 'zv-guide-workspace__eyebrow', 'Jouw voortgang');
    var heading = createElement('h2', 'zv-guide-workspace__heading', 'Volg de stappen');
    var progressCopy = createElement('p', 'zv-guide-workspace__progress-copy');
    var progressLabel = createElement('span', '', 'Voortgang');
    var progressValue = createElement('span', '', 'Stap 1 van ' + steps.length);
    progressValue.setAttribute('aria-live', 'polite');
    progressCopy.append(progressLabel, progressValue);

    var progress = createElement('div', 'zv-guide-workspace__progress');
    progress.setAttribute('role', 'progressbar');
    progress.setAttribute('aria-valuemin', preflightSections.length ? '0' : '1');
    progress.setAttribute('aria-valuemax', String(steps.length));
    var progressBar = createElement('span', 'zv-guide-workspace__progress-bar');
    progress.appendChild(progressBar);

    var jump = createElement('label', 'zv-guide-workspace__jump');
    var jumpLabel = createElement('span', '', 'Ga direct naar een stap');
    var jumpSelect = createElement('select', 'zv-guide-workspace__select');
    jumpSelect.setAttribute('aria-label', 'Ga direct naar een stap');
    steps.forEach(function (step, index) {
      var option = createElement('option', '', (index + 1) + '. ' + (step.getAttribute('data-step-title') || 'Stap ' + (index + 1)));
      option.value = String(index);
      jumpSelect.appendChild(option);
    });
    jump.append(jumpLabel, jumpSelect);

    var nav = createElement('ol', 'zv-guide-workspace__nav');
    var navButtons = steps.map(function (step, index) {
      var item = createElement('li');
      var button = createElement('button', 'zv-guide-workspace__nav-button');
      button.type = 'button';
      button.setAttribute('data-zv-guide-go', String(index));
      var indexNode = createElement('span', 'zv-guide-workspace__nav-index', String(index + 1));
      indexNode.setAttribute('aria-hidden', 'true');
      var title = step.getAttribute('data-step-title') || 'Stap ' + (index + 1);
      var label = createElement('span', 'zv-guide-workspace__nav-label', title);
      button.append(indexNode, label);
      item.appendChild(button);
      nav.appendChild(item);
      return button;
    });

    rail.append(eyebrow, heading, progressCopy, progress, jump, nav);

    var main = createElement('div', 'zv-guide-workspace__main');
    var stage = createElement('div', 'zv-guide-workspace__stage');
    stage.setAttribute('data-zv-guide-stage', '');
    steps.forEach(function (step) { stage.appendChild(step); });

    var controls = createElement('div', 'zv-guide-workspace__controls');
    var back = createElement('button', 'zv-guide-workspace__button zv-guide-workspace__button--back', 'Vorige stap');
    back.type = 'button';
    var next = createElement('button', 'zv-guide-workspace__button zv-guide-workspace__button--next');
    next.type = 'button';
    var nextLabel = createElement('span', '', 'Volgende stap');
    next.append(nextLabel, createChevron('zv-guide-workspace__button-arrow'));
    controls.append(back, next);

    var preflight = null;
    if (preflightSections.length) {
      preflight = createElement('section', 'zv-guide-preflight');
      preflight.setAttribute('aria-labelledby', 'zv-guide-preflight-title');
      var preflightHeader = createElement('div', 'zv-guide-preflight__header');
      var preflightEyebrow = createElement('p', 'zv-guide-preflight__eyebrow', 'Eerst controleren');
      var preflightTitle = createElement('h2', 'zv-guide-preflight__title', 'Klaar om te beginnen?');
      preflightTitle.id = 'zv-guide-preflight-title';
      preflightTitle.setAttribute('tabindex', '-1');
      var preflightText = createElement(
        'p',
        'zv-guide-preflight__text',
        'Zie je beide onderdelen al in dezelfde Home? Dan kun je direct naar de volgende stap.'
      );
      preflightHeader.append(preflightEyebrow, preflightTitle, preflightText);
      preflight.appendChild(preflightHeader);

      preflightSections.forEach(function (item) {
        refinePrerequisites(item.context);
        item.source.classList.add('zv-guide-preflight__source');
        preflight.appendChild(item.source);
      });
      main.appendChild(preflight);
    }

    main.append(stage, controls);
    workspace.append(rail, main);
    pageParent.insertBefore(workspace, firstSource);

    sourceSections.forEach(function (source) { source.classList.add('zv-guide-source-section'); });
    contextAssignments.forEach(function (assignment) {
      assignment.source.classList.add('zv-guide-context-section');
      assignment.target.appendChild(assignment.source);
    });
    legacyContactSections.forEach(function (source) { source.classList.add('zv-guide-legacy-contact'); });

    var contact = createElement('section', 'zv-guide-contact-cta');
    contact.setAttribute('aria-labelledby', 'zv-guide-contact-title');
    var contactCopy = createElement('div', 'zv-guide-contact-cta__copy');
    var contactEyebrow = createElement('p', 'zv-guide-contact-cta__eyebrow', 'Hulp nodig?');
    var contactTitle = createElement('h2', 'zv-guide-contact-cta__title', 'Kom je niet verder?');
    contactTitle.id = 'zv-guide-contact-title';
    var contactText = createElement('p', 'zv-guide-contact-cta__text', 'Bekijk de contactmogelijkheden. We helpen je graag verder met de installatie.');
    var contactLink = createElement('a', 'zv-guide-contact-cta__link');
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var guideIndexUrl = shopRoot.replace(/\/$/, '') + '/pages/instellen';
    contactLink.href = shopRoot.replace(/\/$/, '') + '/pages/contact';
    contactLink.append(createElement('span', '', 'Naar contact'), createChevron('zv-guide-contact-cta__arrow'));
    contactCopy.append(contactEyebrow, contactTitle, contactText);
    contact.append(contactCopy, contactLink);
    pageParent.insertBefore(contact, firstSource);
    document.documentElement.classList.add('zv-guides-enhanced');

    var activeIndex = preflight ? -1 : 0;

    function setNextLabel(label) {
      nextLabel.textContent = label;
    }

    function updateHash(index) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.hash = 'stap-' + (index + 1);
      window.history.replaceState(null, '', url.toString());
    }

    function showStep(index, options) {
      options = options || {};
      activeIndex = Math.max(0, Math.min(index, steps.length - 1));

      if (preflight) preflight.hidden = true;
      stage.hidden = false;
      controls.hidden = false;

      steps.forEach(function (step, stepIndex) {
        step.hidden = stepIndex !== activeIndex;
        step.setAttribute('aria-hidden', stepIndex === activeIndex ? 'false' : 'true');
      });

      navButtons.forEach(function (button, buttonIndex) {
        if (buttonIndex === activeIndex) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });

      var completed = activeIndex + 1;
      progressValue.textContent = 'Stap ' + completed + ' van ' + steps.length;
      progress.setAttribute('aria-valuenow', String(completed));
      progressBar.style.width = ((completed / steps.length) * 100) + '%';
      jumpSelect.value = String(activeIndex);
      back.disabled = activeIndex === 0 && !preflight;
      setNextLabel(activeIndex === steps.length - 1 ? 'Handleiding afronden' : 'Volgende stap');

      if (options.updateHash !== false) updateHash(activeIndex);

      if (options.scroll) {
        var headerOffset = 110;
        var top = workspace.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      if (options.focus) {
        var title = steps[activeIndex].querySelector('.zv-guide-step__title');
        if (title) title.focus({ preventScroll: true });
      }

      var activeNav = navButtons[activeIndex];
      if (activeNav && activeNav.scrollIntoView) {
        activeNav.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    function showPreflight(options) {
      if (!preflight) return;
      options = options || {};
      activeIndex = -1;
      preflight.hidden = false;
      stage.hidden = true;
      controls.hidden = false;

      steps.forEach(function (step) {
        step.hidden = true;
        step.setAttribute('aria-hidden', 'true');
      });
      navButtons.forEach(function (button) { button.removeAttribute('aria-current'); });

      progressValue.textContent = 'Voorbereiding';
      progress.setAttribute('aria-valuenow', '0');
      progressBar.style.width = '0%';
      back.disabled = true;
      setNextLabel('Volgende stap');

      if (options.updateHash !== false && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.hash = '';
        window.history.replaceState(null, '', url.toString());
      }

      if (options.scroll) {
        var headerOffset = 110;
        var top = workspace.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      if (options.focus) preflightTitle.focus({ preventScroll: true });
    }

    nav.addEventListener('click', function (event) {
      var button = event.target.closest('[data-zv-guide-go]');
      if (!button) return;
      showStep(Number(button.getAttribute('data-zv-guide-go')), { scroll: true, focus: true });
    });

    jumpSelect.addEventListener('change', function () {
      showStep(Number(jumpSelect.value), { scroll: true, focus: true });
    });

    back.addEventListener('click', function () {
      if (preflight && activeIndex === 0) {
        showPreflight({ scroll: true, focus: true });
        return;
      }
      showStep(activeIndex - 1, { scroll: true, focus: true });
    });

    next.addEventListener('click', function () {
      if (activeIndex < 0) {
        showStep(0, { scroll: true, focus: true });
        return;
      }
      if (activeIndex < steps.length - 1) {
        showStep(activeIndex + 1, { scroll: true, focus: true });
        return;
      }
      window.location.assign(guideIndexUrl);
    });

    var hashMatch = window.location.hash.match(/^#stap-(\d+)$/);
    var initialIndex = hashMatch ? Number(hashMatch[1]) - 1 : 0;

    if (preflight && !hashMatch) {
      showPreflight({ updateHash: false });
    } else {
      showStep(initialIndex, { updateHash: false });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGuide);
  else initGuide();
})();
